module.exports = __webpack_public_path__ + "media/club/products-illustration-f0b7afca.webp";